import _ from 'lodash';
const files = require.context('.', false, /\.js$/);
const config = [];
var id = -1;
files.keys().forEach((key) => {
  if (key === './index.js') {
    return;
  }
  id = _.isNaN(parseInt(/\d+/.exec(key))) !== true ? parseInt(/\d+/.exec(key)) : id;
  if (key === './pageStart.js') {
    config.push(
      _.extend(files(key).default, {
        id: -1,
        start: true,
      })
    );
  } else if (key === './pageEnd.js') {
    config.push(
      _.extend(files(key).default, {
        id: id + 1,
        stop: true,
      })
    );
  } else {
    config.push(_.extend(files(key).default, { id }));
  }
});
export default config;
